import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { OccupationQuery, TotalRevenueQuery } from '../queries';
import { DINER_REVENUE } from '../../constants';

export class DinerRevenueCalculator extends Calculator {
  kpiType = DINER_REVENUE;

  async calculateKPI() {
    const currentRevenueResponse = await this.executeUncubeQuery(TotalRevenueQuery, this.currentPeriod);
    const currentOccupationResponse = await this.executeUncubeQuery(OccupationQuery, this.currentPeriod);
    const currentDinerRevenue = this.getDinerRevenue(currentRevenueResponse, currentOccupationResponse);

    let props;
    if (this.previousPeriod) {
      const previousRevenueResponse = await this.executeUncubeQuery(TotalRevenueQuery, this.previousPeriod);
      const previousOccupationResponse = await this.executeUncubeQuery(OccupationQuery, this.previousPeriod);
      const previousDinerRevenue = this.getDinerRevenue(previousRevenueResponse, previousOccupationResponse);
      props = this.getData(currentDinerRevenue, previousDinerRevenue);
    } else props = this.getDataIfNoPreviousPeriod(currentDinerRevenue);
    return this.getModelToInstance(props);
  }

  getDinerRevenue(revenueResponse, occupationResponse) {
    const rawRevenue = revenueResponse.data.result[0][0];
    const rawOccupation = occupationResponse.data.result[0][0];
    const dinerRevenue = rawRevenue / rawOccupation;
    return (rawOccupation !== 0) ? dinerRevenue : null;
  }
}
